import { render, staticRenderFns } from "./AppInputImageTrans.vue?vue&type=template&id=79d4b704"
import script from "./AppInputImageTrans.vue?vue&type=script&lang=js"
export * from "./AppInputImageTrans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports